import { useEffect } from 'react';
import window from 'global/window';
import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { useSelector } from 'react-redux';

import { Spinner } from 'components/Loading';

import { selectUser } from 'services/Authentication/selectors';
import { historyPush } from 'utils/historyPush.utils';

export default (Component) => (props) => {
  const user = useSelector(selectUser());
  const history = useHistory();

  const checkAuth = (isAuthenticated) => {
    if (!isAuthenticated) {
      historyPush(history, '/login');
    }
  };

  useEffect(() => {
    let authToken = null;

    try {
      authToken = window.localStorage.getItem('api_token');
    } catch {
      Sentry.addBreadcrumb({
        level: 'warning',
        category: 'browser',
        message: 'Local Storage is not available.',
      });
    }

    try {
      checkAuth(Boolean(user || authToken));
    } catch {
      checkAuth(false);
    }
  });

  return user ? <Component {...props} /> : <Spinner />;
};
